function ReturnIcon(repair, dateString, fire1, fire2, fire3, Irepair, buttons, id) {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  if (!dateString) {
    if (buttons.includes("button3") && !repair) {
      return fire3;
    } else if (buttons.includes("button3") && repair) {
      return Irepair;
    } else if (!buttons.includes("button3") && !repair) {
      return null;
    }
  }

  const [day, month, year] = dateString.split(".").map(Number);
  const date = new Date(year, month - 1, day);

  const deltaDays = Math.abs(Math.floor((date - currentDate) / (1000 * 60 * 60 * 24)));

  if (deltaDays > 32) {
    if (buttons.includes("button3") && !repair) {
      return fire3;
    } else if (buttons.includes("button3") && repair) {
      return Irepair;
    } else if (!buttons.includes("button3") && !repair) {
      return null;
    }
  } else if (deltaDays <= 32 && date.getMonth() + 1 !== currentDate.getMonth() + 1) {
    if (buttons.includes("button2") && !repair) {
      return fire2;
    } else if (buttons.includes("button2") && repair) {
      return Irepair;
    } else if (!buttons.includes("button2") && !repair) {
      return null;
    }
  } else if (date.getMonth() + 1 === currentDate.getMonth() + 1) {
    if (buttons.includes("button1") && !repair) {
      return fire1;
    } else if (buttons.includes("button1") && repair) {
      return Irepair;
    } else if (!buttons.includes("button1") && !repair) {
      return null;
    }
  }
}

export default ReturnIcon;
